export default __webpack_public_path__ + "media/images/brands/expmessenger/backgrounds/bg-04-689355653e11945b3e05d4adfbd10d05.jpg";